import AuthLayout from './AuthLayout';
import LogoutButton from '../../Components/UI/LogoutButton';

const FlowErrorCard = ({ variant, message, onRetry, isRetrying, onLogout }) => (
    <AuthLayout variant={variant}>
        <div className="flex-1 flex flex-col justify-center">
            <div className="mb-10">
                <p className="cv2-auth-eyebrow font-spaceMono text-[9px] tracking-[1.4px] uppercase mb-3.5">
                    One Moment
                </p>
                <h1 className="font-aeonik font-normal text-[38px] leading-[44px] tracking-[-0.9px] text-cv2-foreground normal-case mb-3">
                    Couldn't Check<br />Your Account
                </h1>
                <p className="cv2-auth-subcopy-strong font-aeonik text-sm leading-[22px] normal-case">
                    {message} You're signed in — retry to continue, or log out and sign in again.
                </p>
            </div>

            <div className="cv2-auth-row border-t" />

            <button
                type="button"
                onClick={onRetry}
                disabled={isRetrying}
                className="mt-7 w-full h-12 bg-claraview-secondary hover:brightness-110 disabled:opacity-50 transition-all rounded-[3px] font-spaceMono text-[11px] tracking-[1.2px] text-claraview-quaternary uppercase"
            >
                {isRetrying ? 'Checking…' : 'Retry'}
            </button>

            <div className="mt-4 flex justify-center">
                <LogoutButton onLogout={onLogout} />
            </div>
        </div>
    </AuthLayout>
);

export default FlowErrorCard;
